import React from 'react';
import MypagInquiryContainer from 'containers/MypagInquiryContainer/MypagInquiryContainer';

export default function MypagInquiryPage() {
    return (
        <MypagInquiryContainer />
    )
}
